(() => {
  const node = document.querySelector('[data-bro-signup-config]');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch { return; }
  const forms = new Map([['Ve2Caq','cart'], ['TNJ2en','signup_page'], ['TNJL6P','footer']]);
  const popup = document.querySelector('[data-bro-wp]');
  const teaser = document.querySelector('[data-bro-signup-teaser]');
  const prefix = 'bro_retail_signup_v1_';
  const read = key => { try { return localStorage.getItem(prefix + key); } catch { return null; } };
  const write = (key, value) => { try { localStorage.setItem(prefix + key, value); } catch {} };
  const privateURL = () => /(?:b2b|merch|farm-bureau|state-farm|nmphc|npmhc|dunn|tull|gregory)/i.test(location.pathname + location.search);
  const privateShell = () => !!document.querySelector('body.bro-b2b-merch-mode,body.bro-b2b-cart-active,body.bro-nmphc-cart,body.bro-nmphc-greybg,[data-bro-merch-root]');
  const noindexPage = () => !!document.querySelector('meta[name="robots" i][content*="noindex" i],meta[name="googlebot" i][content*="noindex" i]');
  let cartSafe = config.public === true;
  let opened = false;
  let dismissed = Number(read('dismissed') || 0) > Date.now() - 30 * 86400000;
  let teaserClosed = false;
  let submitted = config.subscribed || read('subscribed') === 'true';
  let identified = true;
  let timerPassed = false;
  let refreshPromise;
  let lastFocus;
  const safe = () => config.public === true && cartSafe && !privateURL() && !privateShell();
  const popupSafe = () => safe() && config.popup === true && !!popup && !noindexPage();
  const updateVisibility = () => {
    document.querySelectorAll('[data-bro-retail-only]').forEach(el => { el.hidden = !safe(); });
    if (teaser) teaser.hidden = opened || teaserClosed || dismissed || !popupSafe() || submitted || identified || !timerPassed || config.purchased || config.page === 'cart' || config.page === 'page' || config.designMode;
    if (popup && opened && !popupSafe()) closePopup(false);
  };
  const refreshCart = async () => {
    if (refreshPromise) return refreshPromise;
    refreshPromise = (async () => {
      try {
        const response = await fetch(config.root + '?section_id=bro-retail-signup-state', {credentials:'same-origin',cache:'no-store'});
        if (!response.ok) throw new Error('cart state unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        cartSafe = html.querySelector('[data-bro-signup-cart-state]')?.dataset.broSignupCartState === 'public';
      } catch { cartSafe = false; }
      updateVisibility();
      return cartSafe;
    })();
    try { return await refreshPromise; } finally { refreshPromise = null; }
  };
  const track = (event, source, formId) => {
    if (typeof window.gtag === 'function') window.gtag('event', event, {form_source:source,form_id:formId});
  };
  const markSubscribed = () => {
    submitted = true;
    write('subscribed', 'true');
    if (teaser) teaser.hidden = true;
  };

  /* ---------- popup ---------- */
  const card = popup?.querySelector('.bro-wp__card');
  const form = popup?.querySelector('[data-bro-wp-form]');
  const input = form?.querySelector('input[type=email]');
  const errorEl = popup?.querySelector('[data-bro-wp-error]');
  const submitBtn = popup?.querySelector('[data-bro-wp-submit]');
  const showStep = step => popup.querySelectorAll('[data-bro-wp-step]').forEach(el => { el.hidden = el.dataset.broWpStep !== step; });
  const onKey = event => {
    if (event.key === 'Escape') closePopup(true);
    if (event.key === 'Tab' && card) {
      const f = [...card.querySelectorAll('button,input:not([tabindex="-1"]),a[href]')].filter(el => !el.closest('[hidden]'));
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  };
  function closePopup(userDismissed) {
    if (!popup || popup.hidden) return;
    popup.hidden = true;
    opened = false;
    document.documentElement.classList.remove('bro-wp-lock');
    document.removeEventListener('keydown', onKey);
    if (userDismissed && !submitted) {
      dismissed = true;
      write('dismissed', String(Date.now()));
      track('bro_email_popup_dismiss', 'popup', 'theme');
    }
    updateVisibility();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  const openPopup = async mode => {
    if (opened || !popupSafe() || submitted || config.designMode) return;
    if (mode === 'auto' && (dismissed || identified || config.purchased)) return;
    if (mode === 'exit' && (dismissed || identified || config.purchased)) return;
    if (!await refreshCart() || !popupSafe()) return;
    opened = true;
    lastFocus = document.activeElement;
    showStep('form');
    popup.hidden = false;
    document.documentElement.classList.add('bro-wp-lock');
    document.addEventListener('keydown', onKey);
    if (teaser) teaser.hidden = true;
    card?.focus({preventScroll:true});
    track('bro_email_popup_view', 'popup', 'theme');
  };
  const validEmail = v => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  const subscribe = async email => {
    const k = config.klaviyo || {};
    const body = {data:{type:'subscription',attributes:{custom_source:k.source || 'BRO Retail Welcome Popup',profile:{data:{type:'profile',attributes:{email,subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}},relationships:{list:{data:{type:'list',id:k.list}}}}};
    const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(k.company), {
      method:'POST',
      headers:{'content-type':'application/vnd.api+json',accept:'application/vnd.api+json',revision:'2026-10-15'},
      body:JSON.stringify(body)
    });
    if (!response.ok) throw new Error('subscribe failed ' + response.status);
  };
  form?.addEventListener('submit', async event => {
    event.preventDefault();
    if (form.elements.company?.value) return;
    const email = (input.value || '').trim();
    errorEl.hidden = true;
    input.removeAttribute('aria-invalid');
    if (!validEmail(email)) {
      errorEl.textContent = 'Please enter a valid email address.';
      errorEl.hidden = false;
      input.setAttribute('aria-invalid','true');
      input.focus();
      return;
    }
    const label = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Unlocking\u2026';
    try {
      await subscribe(email);
      try { window.klaviyo?.identify?.({email}); } catch {}
      markSubscribed();
      track('bro_email_signup', 'popup', 'theme');
      showStep('done');
      card?.focus({preventScroll:true});
    } catch {
      errorEl.textContent = 'We could not complete your signup. Please try again.';
      errorEl.hidden = false;
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = label;
    }
  });

  const copyCode = async btn => {
    const code = popup.querySelector('[data-bro-wp-code]')?.textContent.trim() || config.code || '';
    let ok = false;
    try { await navigator.clipboard.writeText(code); ok = true; } catch {
      try {
        const ta = document.createElement('textarea');
        ta.value = code; ta.setAttribute('readonly',''); ta.style.cssText = 'position:fixed;opacity:0';
        document.body.appendChild(ta); ta.select(); ok = document.execCommand('copy'); ta.remove();
      } catch {}
    }
    btn.textContent = ok ? 'Copied!' : 'Select & copy';
    if (ok) track('bro_email_popup_copy_code', 'popup', 'theme');
    setTimeout(() => { btn.textContent = 'Copy'; }, 2500);
  };

  /* desktop exit intent: once per session, never after signup */
  const sessionRead = key => { try { return sessionStorage.getItem(prefix + key); } catch { return '1'; } };
  const sessionWrite = key => { try { sessionStorage.setItem(prefix + key, '1'); } catch {} };
  const desktop = () => window.matchMedia('(pointer: fine) and (min-width: 750px)').matches;
  const armExitIntent = () => {
    if (!popup || sessionRead('exit_shown')) return;
    const onLeave = event => {
      if (event.relatedTarget || event.clientY > 10) return;
      if (!desktop() || opened || submitted || sessionRead('exit_shown')) return;
      if (config.page === 'cart' || config.page === 'page') return;
      sessionWrite('exit_shown');
      document.removeEventListener('mouseout', onLeave);
      openPopup('exit');
    };
    document.addEventListener('mouseout', onLeave);
  };

  window.addEventListener('klaviyoForms', event => {
    const detail = event.detail || {};
    if (forms.has(detail.formId) && detail.type === 'submit') {
      markSubscribed();
      track('bro_email_signup', forms.get(detail.formId), detail.formId);
    }
  });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-bro-signup-open]')) openPopup('manual');
    if (event.target.closest('[data-bro-wp-close]')) closePopup(true);
    const copyBtn = event.target.closest('[data-bro-wp-copy]');
    if (copyBtn) copyCode(copyBtn);
    if (event.target.closest('[data-bro-signup-dismiss]')) {
      teaserClosed = true;
      dismissed = true;
      write('dismissed', String(Date.now()));
      if (teaser) teaser.hidden = true;
    }
  });
  let cartTimer;
  const onCartChange = () => {
    cartSafe = false;
    updateVisibility();
    clearTimeout(cartTimer);
    cartTimer = setTimeout(refreshCart,400);
  };
  ['cart:updated','cart:refresh','cart:change'].forEach(name => document.addEventListener(name,onCartChange));
  const cartObserver = new MutationObserver(onCartChange);
  ['cart-drawer','#main-cart-footer'].forEach(selector => {
    const el = document.querySelector(selector);
    if (el) cartObserver.observe(el,{childList:true,subtree:true});
  });
  updateVisibility();
  if (!config.public || !config.popup || !popup || config.designMode || privateURL() || noindexPage()) return;
  setTimeout(async () => {
    timerPassed = true;
    try {
      identified = typeof window.klaviyo?.isIdentified === 'function'
        ? await Promise.race([window.klaviyo.isIdentified(),new Promise(resolve => setTimeout(() => resolve(false),2000))])
        : false;
    } catch { identified = false; }
    updateVisibility();
    armExitIntent();
    if (config.page === 'cart' || config.page === 'page') return;
    if (document.visibilityState === 'visible') openPopup('auto');
    else document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') openPopup('auto'); }, {once:true});
  },4000);
})();